<style scoped>
.users-title {
  float: left;
  font-weight: bold;
  font-size: 30px;
}

.table-icons {
  float: right;
}
</style>

<template>
  <div>
    <div class="users-title">Gebruikers</div>
    <div class="block table-icons">
      <b-tooltip label="Gebruiker toevoegen" position="is-top">
        <span class="pointer table-icon" @click="gebruikerToevoegen()">
          <b-icon icon="plus"></b-icon>
        </span>
      </b-tooltip>
      <b-tooltip
        v-if="selected"
        label="Uitnodiging opnieuw sturen"
        position="is-top"
      >
        <span class="pointer" @click="uitnodigingOpnieuwSturen()">
          <b-icon
            v-if="ajaxloading.send_invitation"
            custom-class="fa-spin"
            class="pointer"
            icon="spinner"
          />
          <b-icon v-else class="pointer" icon="envelope" />
        </span>
      </b-tooltip>
      <b-tooltip v-if="selected" label="Gebruiker aanpassen" position="is-top">
        <span class="pointer table-icon" @click="gebruikerAanpassen()">
          <b-icon icon="edit"></b-icon>
        </span>
      </b-tooltip>
      <span v-if="selected">
        <b-tooltip
          label="Gebruiker activeren"
          v-if="selected.status !== 'actief'"
          position="is-top"
        >
          <span class="pointer table-icon" @click="gebruikerActiveren()">
            <b-icon icon="user"></b-icon>
          </span>
        </b-tooltip>
      </span>
      <span v-if="selected">
        <b-tooltip
          label="Gebruiker deactiveren"
          v-if="selected.status === 'actief'"
          position="is-top"
        >
          <span class="pointer table-icon" @click="gebruikerDeactiveren()">
            <b-icon icon="user-slash"></b-icon>
          </span>
        </b-tooltip>
      </span>
      <b-tooltip
        label="Gebruiker verwijderen"
        v-if="selected && selected['status'] === 'gedeactiveerd'"
        position="is-top"
      >
        <span class="pointer table-icon" @click="gebruikerVerwijderen()">
          <b-icon icon="trash"></b-icon>
        </span>
      </b-tooltip>
    </div>

    <br />
    <br />
    <div>
      <b-tabs>
        <b-loading v-model="ajaxloading.get_users" />
        <b-tab-item label="Actieve gebruikers">
          <b-table
            :data="actieve_gebruikers"
            :bordered="true"
            :striped="true"
            :hoverable="true"
            :loading="false"
            :focusable="false"
            :mobile-cards="false"
            :selected.sync="selected"
            @dblclick="gebruikerAanpassen()"
          >
            <b-table-column
              field="id"
              label="ID"
              width="40"
              numeric
              v-slot="props"
            >
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="name" label="Naam" v-slot="props">
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="email" label="Email" v-slot="props">
              <a :href="'mailto:' + props.row.email">{{ props.row.email }}</a>
            </b-table-column>

            <b-table-column field="email" label="Telefoonnummer" v-slot="props">
              <a
                v-if="props.row.telefoonnummer"
                :href="'tel:' + props.row.telefoonnummer"
                >{{ props.row.telefoonnummer }}</a
              >
            </b-table-column>

            <b-table-column field="rol" label="Rol" v-slot="props">
              {{ props.row.rol }}
            </b-table-column>

            <b-table-column label="Uitgenodigd" v-slot="props">
              <span v-if="props.row.uitgenodigd">{{
                formatDatabaseDateHuman(props.row.uitgenodigd) +
                " om " +
                formatDatabaseTime(props.row.uitgenodigd)
              }}</span>
              <span v-else>Nog niet ingelogd.</span>
            </b-table-column>

            <b-table-column
              field="Laatste inlog"
              label="Laatste inlog"
              v-slot="props"
            >
              <span v-if="props.row.laatste_inlog">{{
                formatDatabaseDateHuman(props.row.laatste_inlog) +
                " om " +
                formatDatabaseTime(props.row.laatste_inlog)
              }}</span>
              <span v-else>Nog niet ingelogd.</span>
            </b-table-column>

            <b-table-column field="status" label="Status" v-slot="props">
              {{ props.row.status }}
            </b-table-column>
          </b-table>
        </b-tab-item>
        <b-tab-item label="Archiveerde gebruikers">
          <b-table
            :data="gedeactiveerd_gebruikers"
            :bordered="true"
            :striped="true"
            :hoverable="true"
            :loading="false"
            :focusable="false"
            :mobile-cards="false"
            :selected.sync="selected"
            @dblclick="gebruikerAanpassen()"
          >
            <b-table-column
              field="id"
              label="ID"
              width="40"
              numeric
              v-slot="props"
            >
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="name" label="Naam" v-slot="props">
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="email" label="Email" v-slot="props">
              <a :href="'mailto:' + props.row.email">{{ props.row.email }}</a>
            </b-table-column>

            <b-table-column field="email" label="Telefoonnummer" v-slot="props">
              <a
                v-if="props.row.telefoonnummer"
                :href="'tel:' + props.row.telefoonnummer"
                >{{ props.row.telefoonnummer }}</a
              >
            </b-table-column>

            <b-table-column field="rol" label="Rol" v-slot="props">
              {{ props.row.rol }}
            </b-table-column>

            <b-table-column label="Uitgenodigd" v-slot="props">
              <span v-if="props.row.uitgenodigd">{{
                formatDatabaseDateHuman(props.row.uitgenodigd) +
                " om " +
                formatDatabaseTime(props.row.uitgenodigd)
              }}</span>
              <span v-else>Nog niet ingelogd.</span>
            </b-table-column>

            <b-table-column
              field="Laatste inlog"
              label="Laatste inlog"
              v-slot="props"
            >
              <span v-if="props.row.laatste_inlog">{{
                formatDatabaseDateHuman(props.row.laatste_inlog) +
                " om " +
                formatDatabaseTime(props.row.laatste_inlog)
              }}</span>
              <span v-else>Nog niet ingelogd.</span>
            </b-table-column>

            <b-table-column field="status" label="Status" v-slot="props">
              {{ props.row.status }}
            </b-table-column>
          </b-table>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    gebruikers() {
      return this.$store.getters["adminUsers/users"];
    },
    actieve_gebruikers() {
      return this.gebruikers.filter((a) => a.status === "actief");
    },
    gedeactiveerd_gebruikers() {
      return this.gebruikers.filter((a) => a.status !== "actief");
    },
  },
  methods: {
    gebruikerToevoegen() {
      this.$router.push({ name: "gebruiker-toevoegen" });
    },
    gebruikerAanpassen() {
      this.$router.push({
        name: "gebruiker-aanpassen",
        params: { user: this.selected.id },
      });
    },
    gebruikerActiveren() {
      this.$buefy.dialog.confirm({
        title: "Gebruiker activeren",
        message:
          'Weet je zeker dat je gebruiker "' +
          this.selected.name +
          '" wil activeren?',
        confirmText: "Activeren",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () =>
          this.$store
            .dispatch("adminUsers/activateUser", this.selected)
            .then(() => {
              this.selected = null;
              this.$buefy.toast.open("Gebruiker weer actief gemaakt");
            }),
      });
    },
    gebruikerDeactiveren() {
      this.$buefy.dialog.confirm({
        title: "Gebruiker deactiveren",
        message:
          'Weet je zeker dat je gebruiker "' +
          this.selected.name +
          '" wil deactiveren?',
        confirmText: "Deactiveren",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () =>
          this.$store
            .dispatch("adminUsers/deactivateUser", this.selected)
            .then(() => {
              this.selected = null;
              this.$buefy.toast.open("Gebruiker gedeactiveerd");
            }),
      });
    },
    uitnodigingOpnieuwSturen() {
      this.$buefy.dialog.confirm({
        title: "Uitnodiging sturen",
        message:
          "Wilt u de uitnodiging voor " +
          this.selected.name +
          " opnieuw versturen?",
        type: "is-info",
        hasIcon: true,
        onConfirm: () =>
          this.$store.dispatch("adminUsers/resendInvitation", this.selected),
      });
    },
    gebruikerVerwijderen() {
      this.$buefy.dialog.confirm({
        title: "Gebruiker verwijderen",
        message:
          'Weet je zeker dat je gebruiker "' +
          this.selected.name +
          '" wil verwijderen?',
        confirmText: "Verwijderen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () =>
          this.$store
            .dispatch("adminUsers/gebruikerVerwijderen", this.selected)
            .then(() => {
              this.selected = null;
              this.$buefy.toast.open("Gebruiker verwijderd");
            }),
      });
    },
  },
  mounted() {},
};
</script>
